import { render, staticRenderFns } from "./Keyboxes.vue?vue&type=template&id=0c993a32&scoped=true"
import script from "./Keyboxes.vue?vue&type=script&lang=js"
export * from "./Keyboxes.vue?vue&type=script&lang=js"
import style0 from "./Keyboxes.vue?vue&type=style&index=0&id=0c993a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c993a32",
  null
  
)

export default component.exports